import { StyleSheet } from 'react-native';
import { appColors, appFonts } from 'zen-core-elements/src/shared/constants';

export const storeImageGalleryStyle = StyleSheet.create({
  flex: {
    flex: 1,
    backgroundColor: appColors.lightBackgroundColor
  },
  container: {
    flex: 1,
    backgroundColor: appColors.light,
  },
  headerContainer: {
    backgroundColor: appColors.light,
    borderBottomColor: appColors.borderColor,
  },
  tabContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    padding: 11,
  },
  tabBadgeStyle: {
    borderRadius: 25 / 2,
    backgroundColor: appColors.activeColor,
    marginLeft: 5,
  },
  tabBadgeTextStyle: {
    fontSize: 10,
    color: appColors.light,
    fontFamily: appFonts.bold,
  },
  searchbarView: {
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: 10,
    marginVertical: 13,
    gap: 8,
    zIndex: 1000,
  },
  storeImageHeader: {
    paddingTop: 3,
    paddingHorizontal: 7,
    flexDirection: 'row',
    alignItems: 'center',
  },
  storeImageHeaderText: {
    paddingBottom: 10,
    borderBottomColor: appColors.primary,
    paddingHorizontal: 10,
    textAlign: 'center',
    textTransform: 'capitalize',
  },
  headerBadgeTextStyle: {
    fontSize: 12,
    color: appColors.light,
    fontFamily: appFonts.bold,
  },
  flatlistView: {
    flex: 1,
    marginHorizontal: 8,
    marginTop: 10,
  },
  deleteIconView: {
    alignSelf: 'flex-end',
    backgroundColor: appColors.darkRed,
    borderRadius: 50,
    alignItems: 'center',
    justifyContent: 'center',
    height: 55,
    width: 55,
    position: 'absolute',
    bottom: 25,
    right: 25,
  },
  addIconView: {
    alignSelf: 'flex-end',
    backgroundColor: appColors.activeColor,
    borderRadius: 50,
    alignItems: 'center',
    justifyContent: 'center',
    height: 55,
    width: 55,
    position: 'absolute',
    bottom: 25,
    right: 25,
  },
  cameraContainerStyle: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10
  },
  uploadButtonText: {
    textAlign: 'center',
    color: appColors.light,
    textTransform: 'capitalize',
    fontFamily: appFonts.bold,
    marginHorizontal: 20,
  },
  uploadButton: {
    backgroundColor: appColors?.primary,
    borderRadius: 8
  },
  renderItemContainer: {
    paddingBottom: 20,
    marginHorizontal: 20,
    marginLeft: 5,
    marginRight: 5,
  },
  imageStyle: {
    width: 100,
    height: 80,
    resizeMode: 'contain',
  },
  divider: {
    marginVertical: 10,
    width: '100%',
  },
  itemnamestyle: {
    textAlign: 'center',
    flexWrap: 'wrap',
    color: appColors.primary,
  },
  renderSubView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  aligncenter: {
    alignItems: 'center',
  },
  browseFileView: {
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 8,
    marginTop: '5%',
    borderColor: appColors.borderColor,
    height: 100,
  },
  imageListContainer: {
    marginHorizontal: 20,
    flexDirection: 'row',
    flex: 1,
    flexWrap: 'wrap',
    marginTop: 15,
  },
  removeImageStyle: {
    position: 'absolute',
    right: -7,
    top: -5,
  },

  noteTextStyle: {
    paddingTop: 10,
    textAlign: 'justify',
    lineHeight: 18,
    marginHorizontal: 15,
  },
  uploadImageContainer: {
    marginTop: 3,
    flexDirection: 'row',
    alignItems: 'center',
  },
  error: {
    fontFamily: appFonts.medium,
    marginLeft: 0,
  },
  inputStyle: {
    padding: 0,
    fontFamily: appFonts.medium,
  },
  renameTextView: {
    marginTop: 10,
    paddingHorizontal: 15
  },
  buttonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 25,
  },
  buttonStyle: {
    backgroundColor: appColors.primary,
    width: 120,
  },
  buttonText: {
    textAlign: 'center',
    color: appColors.light,
    fontFamily: appFonts.bold,
    marginHorizontal: 20,
  },
  viewImageStyle: {
    width: 250,
    height: 250,
    alignSelf: 'center',
  },
});
